import React, { Component } from "react";

import Notify from "../../../../utils/Notify";
import Backend from "../../../../utils/Backend";
import General from "../../../../utils/General";

import Separator from "../../common/Separator";

import AddNewCompanyMemberModal from "../../modals/AddNewCompanyMemberModal";
import ManageStaffTable from "../../tables/manage-staff/ManageStaffTable";

export default class ManageStaff extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companyMembers: [],
    };
  }

  componentDidMount() {
    this._getCompanyMembers();
  }

  _getCompanyMembers() {
    let companyId = this.props.vendorId;

    this.setState({
      isLoading: true,
    });

    Backend.getCompanyMembers(companyId)
      .then((companyMembers) => {
        this.setState({ companyMembers, isLoading: false });
      })
      .catch((error) => {
        Notify.error(error.message);
        this.setState({ isLoading: false });
      });
  }

  _addStaff(companyMemberId, venueId) {
    this.setState({ isLoading: true });

    Backend.addStaff(companyMemberId, venueId)
      .then(() => {
        this._getCompanyMembers();
        Notify.success("Added");
      })
      .catch((error) => {
        Notify.error(error.message);
        this.setState({ isLoading: false });
      });
  }

  _removeStaff(companyMemberId, venueId) {
    this.setState({ isLoading: true });

    Backend.removeStaff(companyMemberId, venueId)
      .then(() => {
        this._getCompanyMembers();
        Notify.success("Removed");
      })
      .catch((error) => {
        Notify.error(error.message);
        this.setState({ isLoading: false });
      });
  }

  render() {
    let { companyMembers, showAddNewCompanyMember } = this.state;

    return (
      <>
        <div className="py-8 px-8 py-lg-20 px-lg-10">

        {/* Legacy Interface - Quick Toggle */}
          <div className="row">
            <div className=" col-xxl-8">
              <div className="card card-custom">
                <div className="card-header">
                  <h3 className="card-title">Quick Add/Remove (Legacy)</h3>
                </div>
                <div className="card-body">
                  <h6 className="mb-5 text-muted">
                    Quick toggle to add/remove existing company members:
                  </h6>
                  {companyMembers?.map((companyMember, index) => {
                    
                    let isStaffMember =
                      companyMember.venues.find(
                        (venueId) => venueId == this.props?.venueId
                      ) != null;

                    return (
                      <>
                        <div className="form-group row" key={General.uuid()}>
                          <div className="col-md-8 mt-3">
                            <label>
                              {" "}
                              {General.toTitleCase(
                                companyMember?.user.first_name
                              )}{" "}
                              {General.toTitleCase(
                                companyMember?.user.last_name
                              )}
                            </label>
                          </div>

                          <div className="col-md-4 text-right">
                            <span className="switch switch-icon">
                              <label>
                                <input
                                  className="reminder-toggle"
                                  type="checkbox"
                                  checked={isStaffMember}
                                  onChange={(e) => {
                                    let checked = e.target.checked;

                                    if (checked) {
                                      this._addStaff(
                                        companyMember.user.id,
                                        this.props?.venueId
                                      );
                                    } else {
                                      this._removeStaff(
                                        companyMember.user.id,
                                        this.props?.venueId
                                      );
                                    }
                                  }}
                                />
                                <span></span>
                              </label>
                            </span>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          {/* New Staff Management Table */}
          

          
        </div>

        <AddNewCompanyMemberModal
          show={showAddNewCompanyMember}
          vendorId={this.props.vendorId}
          venueId={this.props.venueId}
          onUpdated={(companyMember) => {
            this._getCompanyMembers();

            this.setState({
              showAddNewCompanyMember: false,
            });
          }}
          onHide={() =>
            this.setState({
              showAddNewCompanyMember: false,
            })
          }
        />
      </>
    );
  }
}
